// Combat balance constants. Per plan §4: edit data, not module logic.

export const RESIST_CAP = 0.75; // damage reduction can never exceed 75%
export const CRIT_CHANCE = 0.1;
export const CRIT_MULTIPLIER = 1.5;
export const VARIANCE = 0.1; // ±10% damage roll
